import React, { Component } from 'react'
import HeaderCenter from './HeaderCenter'
import HeaderTopNav from './HeaderTopNav'
import HeaderSearch from './HeaderSearch'
import HeaderLogo from './HeaderLogo'
import Login from './Login'
import './user-grade-icon.less'
import styles from './common.module.less'
import './index.less'
import { throttle } from 'lodash'
import Utils from './lib/utils'
const channelList = [{
  domain: '//tv.youku.com',
  name: '剧集',
  enable: false
}, {
  domain: '//movie.youku.com',
  name: '电影',
  enable: false
}, {
  domain: '//child.youku.com',
  name: '少儿',
  enable: false
}, {
  domain: '//zy.youku.com',
  name: '综艺',
  enable: false
}, {
  domain: '//comic.youku.com',
  name: '动漫',
  enable: false
}, {
  domain: '//jilupian.youku.com',
  name: '纪实',
  enable: false
}, {
  domain: '//culture.youku.com',
  name: '文化',
  enable: false
}, {
  domain: '//sports.youku.com',
  name: '体育',
  enable: false
}, {
  domain: '//www.laifeng.com',
  name: '来疯',
  enable: false
}, {
  domain: '//edu.youku.com',
  name: '教育',
  enable: false
}, {
  domain: '//game.youku.com',
  name: '游戏',
  enable: false
}, {
  domain: '//live.youku.com',
  name: '直播',
  enable: false
}, {
  domain: '//fashion.youku.com',
  name: '时尚',
  enable: false
}, {
  domain: '//music.youku.com',
  name: '音乐',
  enable: false
}, {
  domain: '//travel.youku.com',
  name: '旅游',
  enable: false
}, {
  domain: '//fun.youku.com',
  name: '搞笑',
  enable: false
}, {
  domain: '//auto.youku.com',
  name: '汽车',
  enable: false
}, {
  domain: '//baby.youku.com',
  name: '亲子',
  enable: false
}, {
  domain: '//ent.youku.com',
  name: '娱乐',
  enable: false
}, {
  domain: '//news.youku.com',
  name: '资讯',

  enable: false
}, {
  domain: '//gongyi.youku.com/',
  name: '公益',
  enable: false
}, {
  domain: '//life.youku.com',
  name: '生活',
  enable: false
}, {
  domain: '//list.youku.com/category/show/c_97.html',
  name: '片库',
  enable: false
}, {
  domain: '//tech.youku.com',
  name: '科技',
  enable: false
}, {
  domain: '//finance.youku.com',
  name: '财经',
  enable: false
}, {
  domain: '//faxian.youku.com/',
  name: '发现',
  enable: false
}]

const stickChannelList = [{
  domain: '//tv.youku.com',
  name: '剧集',
  enable: false
}, {
  domain: '//movie.youku.com',
  name: '电影',
  enable: false
}, {
  domain: '//zy.youku.com',
  name: '综艺',
  enable: false
}]
class Header extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isWhite: false, // 状态
      focusWhite: false, // 强制白色背景
      currentDomain: null, // 当前的频道
      isIndex: true
    }
    this.scrollHandel = throttle(this.headerScroll.bind(this), 200)
    this.currentChannel = null
  }
  checkIndex () {
    if (!this.currentChannel || location.host === 'www.youku.com' || location.host === 'youku.com') {
      this.setState({ isIndex: true })
    } else {
      this.setState({ isIndex: false })
    }
  }

  getCurrentChannel () {
    const host = location.host
    const hostParam = Utils.getUrlParams().host
    if (host === 'youku.com' || hostParam === 'youku.com') {
      return
    }
    channelList.map((channel) => {
      if (channel.domain.indexOf(host) > -1 || (hostParam && channel.domain.indexOf(hostParam) > -1)) {
        this.currentChannel = channel
      }
    })
  }

  componentDidMount () {
    this.getCurrentChannel()
    this.checkIndex()
    if (typeof window !== 'undefined') {
      this.Login = Login
      window.addEventListener('scroll', this.scrollHandel)
    }
    // 初始状态就是距离顶部
    let scrollTop = document.documentElement.scrollTop
    if (scrollTop > 490) {
      this.setState({
        isWhite: true
      })
    }
  }

  componentWillUnmount () {
    // if (typeof window !== 'undefined') {
    //   window.removeEventListener('scroll', this.scrollHandel)
    // }
  }

  shouldComponentUpdate (nextProps, nextState) {
    let updateFlag = false
    for (const key in nextState) {
      if (nextState[key] !== this.state[key]) {
        updateFlag = true
      }
    }
    return updateFlag
  }

  headerScroll (e) {
    if (this.state.focusWhite) {
      return
    }
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    if (scrollTop > 490) {
      this.setState({
        isWhite: true
      })
    } else {
      this.setState({
        isWhite: false
      })
    }
  }
  render () {
    let _className = ''
    if (this.state.isWhite || this.state.focusWhite) {
      _className = ' white'
    }
    return (
      // g-header-fixed
      <div className={`g-header ${_className} top70`}>
        <div className='g-header-container'>
          <div className={styles.container}>
            <div className='g-box'>
              <HeaderLogo currentChannel={this.currentChannel} />
              <HeaderTopNav stickChannelList={stickChannelList} channelList={channelList} isIndex={this.state.isIndex} />
              <HeaderSearch />
              <HeaderCenter Login={Login} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Header
